import { Tabs } from "antd";
import HistoryStatusCard from "../History";
import UsageTrend from "../UsageTrend";
import FilterMenu from "./FilterMenu";
import { useSearchParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { appName } from "../../../config/url-config";

const DetailCard = () => {
  var currentDate = new Date().toISOString().split("T")[0];

  const [searchParams, setSearchParams] = useSearchParams();
  const [msisdn, setMsisdn] = useState("");
  const [cardId, setCardId] = useState();
  const [selectedTabs, setSelectedTabs] = useState(
    searchParams.get("tabs") ?? "1"
  );

  const handleTabChange = (key) => {
    setSelectedTabs(key);

    setSearchParams({
      ...Object.fromEntries(searchParams.entries()),
      tabs: key,
      strDate: searchParams.get("strDate") ?? currentDate,
      endDate: searchParams.get("endDate") ?? currentDate,
    });
  };

  useEffect(() => {
    setSearchParams({
      tabs: selectedTabs,
      strDate: currentDate,
      endDate: currentDate,
    });

    if (searchParams.get("id")) {
      setSearchParams({
        ...Object.fromEntries(searchParams.entries()),
        id: searchParams.get("id") ?? "",
      });
    }

    document.title = `Detail Card | ${appName}`;
    // eslint-disable-next-line
  }, []);

  const items = [
    {
      key: "1",
      label: "History",
      children: <HistoryStatusCard id={cardId} />,
    },
    {
      key: "2",
      label: "Usage Trend",
      children: <UsageTrend id={cardId} />,
    },
  ];

  const onQuery = (values) => {
    setCardId(values.id);
  };

  return (
    <>
      <FilterMenu onHandleQuery={onQuery} />
      <br />
      <Tabs
        defaultActiveKey={selectedTabs}
        type="card"
        size={"small"}
        items={items}
        onChange={handleTabChange}
      />
    </>
  );
};

export default DetailCard;
